import { Injectable } from '@angular/core';
import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import { environment } from '../../environments/environment.production';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private userPool = new CognitoUserPool({
    UserPoolId: environment.userPoolId,
    ClientId: environment.userPoolWebClientId,
  });

  private jwtToken: string | null = null;


  isAuthenticated(): boolean {
    const currentUser: CognitoUser | null = this.userPool.getCurrentUser();

    // set jwtToken if current user exists
    if (currentUser) {
      currentUser.getSession((err: any, session: any) => {
        if (err || !session.isValid()) {
          console.error('Session invalid:', err);
          this.jwtToken = null;
        } else {
          this.jwtToken = session.getIdToken().getJwtToken();
        }
      });
    } else {
      this.jwtToken = null;
    }

    return !!currentUser;
  }

  getCurrentSession(): Promise<any> {
    return new Promise((resolve, reject) => {
      const user = this.userPool.getCurrentUser();
      if (!user) return reject('No user');
      user.getSession((err: any, session: any) => {
        if (err || !session.isValid()) {
          reject(err || 'Session invalid');
        } else {
          resolve(session);
        }
      });
    });
  }

  login(username: string, password: string): Promise<boolean> {
    const authDetails = new AuthenticationDetails({ Username: username, Password: password });
    const user = new CognitoUser({ Username: username, Pool: this.userPool });

    return new Promise((resolve, reject) => {
      user.authenticateUser(authDetails, {
        onSuccess: result => {
          this.jwtToken = result.getIdToken().getJwtToken();
          resolve(true);
        },
        onFailure: err => {
          console.error('Login failed:', err);
          reject(err)
        }
      });
    });
  }

  logout() {
    const user = this.userPool.getCurrentUser();
    if (user) user.signOut();
    this.jwtToken = null;
  }

  getToken(): string | null {
    return this.jwtToken;
  }

}
